import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  id: number,
 *  projectId: number,
 *  reviewStatusId: number,
 *  communicationStatusId: number,
 *  municipalityId: number,
 *  categoryId: number,
 *  description: string,
 *  locations: Locations,
 *  totalCost: number,
 *  ccbfBudgeted: number,
 *  ccbfSpentToDate: number,
 *  startDate: string,
 *  constructionEnd: string,
 *  files: Array,
 *  links: Links
 *  }} ProjectDetails
 */

/**
 * @typedef {{
 *  longitude: number,
 *  latitude: number,
 *  isPrimary: boolean
 *  }} Locations
 */

/**
 * @typedef {{
 *  url: string,
 *  description: string
 *  }} Links
 */

const api = new Api("api/communications");

/**
 * @param projectId
 * @returns {Promise<AxiosResponse<ProjectDetails[]>>}
 */
export const getProjectDetails = (projectId) =>
  api.get(`/project/${projectId}`);
